import {
  IDeductionRepository,
  ISendRemittanceForApprovalRepositoryParams,
  ICheckRemittanceForApprovalRepositoryResponse,
} from "@/core/repositories/deduction";

export class CheckRemittanceForApprovalUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(
    params: ISendRemittanceForApprovalRepositoryParams
  ): Promise<ICheckRemittanceForApprovalRepositoryResponse> {
    return this.deductionRepository.checkRemittanceForApproval(params);
  }
}
